import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('UpdateProgressButtons').create(({ theme }) => ({
  root: {
    width: '100%',
    position: 'relative',
    display: 'flex',
    gap: '8px',
    height: '40px',
  },

  updateProgressButton: {
    width: '100%',
    position: 'relative',
    background: theme.colors.background.secondary,
    boxShadow: 'none!important',
    gap: '4px',
    overflow: 'hidden',
    height: '100%',
    borderRadius: '8px',
    span: {
      position: 'relative',
      zIndex: 6,
      fontSize: '13px',
      fontWeight: 460,
      color: theme.colors.text.primary,
      textWrap: 'nowrap',
    },
  },

  updateNowButton: {
    background: theme.colors.text.primary,
    gap: '4px',
    width: '70%',
    padding: '8px 12px',
    borderRadius: '8px',
    span: {
      position: 'relative',
      zIndex: 6,
      fontSize: '13px',
      fontWeight: 460,
      color: 'black',
      textWrap: 'nowrap',
    },
  },
}))
